import { Color, Spacing } from '@persona-id/design-tokens';
import styled from 'styled-components';

import { TransitionDuration } from 'design-system/variables/transitions';
import ImageIdCorner from 'images/pictographs/id-corner.svg';

const CornerTopLeft = styled(ImageIdCorner)<{
  $highlightCorners?: boolean;
}>`
  position: absolute;
  top: ${Spacing[3]};
  left: ${Spacing[3]};
  path {
    stroke: ${({ $highlightCorners }) => ($highlightCorners ? Color.CoreGreen400 : null)};
    transition: stroke ${TransitionDuration.Fast};
  }
`;

const CornerTopRight = styled(ImageIdCorner)<{
  $highlightCorners?: boolean;
}>`
  position: absolute;
  top: ${Spacing[3]};
  right: ${Spacing[3]};
  transform: rotate(90deg);
  path {
    stroke: ${({ $highlightCorners }) => ($highlightCorners ? Color.CoreGreen400 : null)};
    transition: stroke ${TransitionDuration.Fast};
  }
`;

const CornerBottomRight = styled(ImageIdCorner)<{
  $highlightCorners?: boolean;
}>`
  position: absolute;
  bottom: ${Spacing[3]};
  right: ${Spacing[3]};
  transform: rotate(180deg);
  path {
    stroke: ${({ $highlightCorners }) => ($highlightCorners ? Color.CoreGreen400 : null)};
    transition: stroke ${TransitionDuration.Fast};
  }
`;

const CornerBottomLeft = styled(ImageIdCorner)<{
  $highlightCorners?: boolean;
}>`
  position: absolute;
  bottom: ${Spacing[3]};
  left: ${Spacing[3]};
  transform: rotate(270deg);
  path {
    stroke: ${({ $highlightCorners }) => ($highlightCorners ? Color.CoreGreen400 : null)};
    transition: stroke ${TransitionDuration.Fast};
  }
`;

interface IdCornersGuideProps {
  highlightCorners?: boolean;
}

export default function IdCornersGuide({ highlightCorners }: IdCornersGuideProps) {
  return (
    <>
      <CornerTopLeft $highlightCorners={highlightCorners} aria-hidden />
      <CornerTopRight $highlightCorners={highlightCorners} aria-hidden />
      <CornerBottomLeft $highlightCorners={highlightCorners} aria-hidden />
      <CornerBottomRight $highlightCorners={highlightCorners} aria-hidden />
    </>
  );
}
